/** Registers the Panel parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parsePanel } from './parser';
const panelRegistration = {
    typeName: 'Panel',
    parser: parsePanel,
};
nodeRegistry.register(panelRegistration);
export * from './parser';
//# sourceMappingURL=index.js.map